import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useTenant } from '../shared/contexts/TenantContext.js';

/**
 * Guard component that checks if a tenant is selected
 * Redirects to login if no tenant is selected
 */
export const TenantGuard: React.FC = () => {
  const { tenant_id } = useTenant();
  const isAuthenticated = localStorage.getItem('astrapeak_auth_token') !== null;

  // If not authenticated or no tenant selected, redirect to login
  if (!isAuthenticated || !tenant_id) {
    return <Navigate to="/login" replace />;
  }

  // Render child routes if authenticated and tenant is selected
  return <Outlet />;
};

export default TenantGuard;
